import { render, staticRenderFns } from "./viewAdminsByDivision.vue?vue&type=template&id=1a36c966&scoped=true"
import script from "./viewAdminsByDivision.vue?vue&type=script&lang=js"
export * from "./viewAdminsByDivision.vue?vue&type=script&lang=js"
import style0 from "./viewAdminsByDivision.vue?vue&type=style&index=0&id=1a36c966&prod&scoped=true&lang=css"
import style1 from "./viewAdminsByDivision.vue?vue&type=style&index=1&id=1a36c966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36c966",
  null
  
)

export default component.exports